'use client'

import type { AddressShippingSwitcherSlideInProps } from '@maestro/commerce-blocks/components/address-shipping-switcher/address-shipping-switcher.types'

import { useTranslations } from 'next-intl'

import { AddressShippingSwitcherItem } from '@maestro/commerce-blocks/components/address-shipping-switcher'
import { useAddressShippingSwitcherSlideIn } from '@maestro/commerce-blocks/components/address-shipping-switcher/batons/use-address-shipping-switcher-slide-in'
import {
  SwitcherEmptyState,
  SwitcherList,
  SwitcherSlideIn,
} from '@maestro/commerce-blocks/components/switcher'

export default function AddressShippingSwitcherSlideIn(
  props: AddressShippingSwitcherSlideInProps
) {
  const { onClose } = props
  const t = useTranslations('commerce-blocks.shipping-address-switcher')

  const { addresses, areAddressesLoading, selectingId, selectAddress } =
    useAddressShippingSwitcherSlideIn(onClose)

  return (
    <SwitcherSlideIn
      isLoading={areAddressesLoading}
      isEmpty={!addresses.length}
      emptyState={
        <SwitcherEmptyState
          title={t('empty-title')}
          description={t('empty-description')}
        />
      }
      onClose={onClose}
    >
      <SwitcherList>
        {addresses.map((address) => (
          <AddressShippingSwitcherItem
            key={`shipping-address-${address.id}`}
            address={address}
            isSelected={!!address.isSelected}
            isPending={selectingId === address.id}
            isDisabled={!!selectingId}
            onSelect={() => selectAddress(address)}
          />
        ))}
      </SwitcherList>
    </SwitcherSlideIn>
  )
}
